<template>
    <configPromocionesFile @refrest="close"/>
</template>

<script>
import { mapActions } from 'vuex';
import configPromocionesFile from './configPromocionesFile.vue';

export default {
    name: "config-promociones-options",
    components: {
        configPromocionesFile,
    },
    methods: {
        ...mapActions(["executeCommit"]),
        close() {
            this.executeCommit({
                mutation: "close_modal",
            });
            this.$emit("refrest");
        }
    }
};
</script>
